
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import { MixinsHomeClick } from '@xt/client/mixins/home'
import type { ContainActivityBtn, CourseItem } from '@xt/client/utils/activities/types'
import AUtils, { formatEndTimeCountdown } from '@xt/client/utils/activities'

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class CourseCard extends Mixins(MixinsHomeClick) {
  @Prop({ required: true }) data!: CourseItem

  timer: ReturnType<typeof setInterval> | null = null
  countDown: string = ''
  btnConfig: ContainActivityBtn | null = null

  get timeShow() {
    return this.countDown ? this.countDown : this.btnConfig ? (this.btnConfig.time ?? this.btnConfig.label) : ''
  }

  clearTick() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  getCountDown(endTime: number) {
    const res = formatEndTimeCountdown(endTime)

    if (!res) return ''

    if (res.days) {
      return `${res.days}天后报名结束`
    }

    return `${res.hours}:${res.minutes}:${res.seconds}后报名结束`
  }

  startTick() {
    if (!this.btnConfig || !this.btnConfig.countdown) return

    const { endTime } = this.btnConfig.countdown

    this.countDown = this.getCountDown(endTime)

    this.timer = setInterval(() => {
      this.countDown = this.getCountDown(endTime)
    }, 1000)
  }

  handleClick() {
    if (this.data.event) {
      this.onClickEvent(this.data.event)
      return
    }
  }

  created(): void {
    this.btnConfig = AUtils.mapContainCourseBtn(this.data)
    this.startTick()
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {
    this.clearTick()
  }
}
